
import { Component, Vue } from 'vue-property-decorator'
@Component({})
export default class App extends Vue {
  created() {
    // this.getUserInfo()
    // 在页面加载时读取 sessionStorage 里的状态信息
    console.log('dddddddddddddddddddddddddddddddddddd')
    if (sessionStorage.getItem("triman_bsrkapp_store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("triman_bsrkapp_store"))))
    }
    // 在页面刷新时将 vuex 里的信息保存到 sessionStorage 里
    window.addEventListener("beforeunload", () => {
      console.log('ffffffffffffffffffffffffffffffff')
      sessionStorage.setItem("triman_bsrkapp_store", JSON.stringify(this.$store.state))
    })
  }
  // getUserInfo() {
  //   return new Promise((resolve, reject) => {
  //     if (this.$store.getters.token) {
  //       this.axios
  //         .get('/user/userInfo')
  //         .then(response => {
  //           let user: any = {}
  //           user.username = response.data.idcard
  //           user.name = response.data.name
  //           user.roles = response.data.authorities.map((item: any) => {
  //             return item.authority
  //           })
  //           user.resource = response.data.resource
  //           this.$store.commit('updateUser', user)
  //         })
  //         .catch(error => {
  //           reject(error)
  //         })
  //     }
  //   })
  // }
}
